export type CatalogThreadClickAction = "toggle-ng" | "view";
export type CatalogImageMaskKind = "ng" | "r18" | null;

interface CatalogMaskOptions {
  isNg: boolean;
  ngRevealed: boolean;
  isR18Hidden: boolean;
}

export interface CatalogMaskVisibility {
  image: boolean;
  text: boolean;
}

export interface CatalogReplyCountVisibilityOptions {
  maskKind: CatalogImageMaskKind;
  showCount: boolean;
  showUnreadCount: boolean;
  unreadCount: number | undefined;
}

export function getCatalogThreadClickAction(options: {
  isNg: boolean;
  ngRevealed: boolean;
}): CatalogThreadClickAction {
  if (options.isNg && !options.ngRevealed) return "toggle-ng";
  return "view";
}

export function getCatalogMaskVisibility(
  options: CatalogMaskOptions,
): CatalogMaskVisibility {
  const isNgHidden = options.isNg && !options.ngRevealed;
  return {
    image: isNgHidden || options.isR18Hidden,
    text: isNgHidden,
  };
}

export function getCatalogImageMaskKind(
  options: CatalogMaskOptions,
): CatalogImageMaskKind {
  if (options.isNg && !options.ngRevealed) return "ng";
  if (options.isR18Hidden) return "r18";
  return null;
}

export function shouldShowCatalogReplyCount(
  options: CatalogReplyCountVisibilityOptions,
): boolean {
  const hasCount =
    options.showCount ||
    (options.showUnreadCount &&
      options.unreadCount !== undefined &&
      options.unreadCount > 0);
  return hasCount && options.maskKind !== "ng";
}
